import { render } from "./FilterListView.vue?vue&type=template&id=3f87f44b&scoped=true"
import script from "./FilterListView.vue?vue&type=script&lang=js"
export * from "./FilterListView.vue?vue&type=script&lang=js"

import "./FilterListView.vue?vue&type=style&index=0&id=3f87f44b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f87f44b"]])

export default __exports__